export default class UpdateApplicationStatusError extends Error {
  constructor(message: string, readonly statusId: string) {
    super(message);
  }
}
